/**
 * 日時の見せ方（画面だけ。紙・API は使わない）。日本時間で出す（端末の時計の地域に左右されない＝receivedStamp と同じ）
 */
const JST = 9 * 3600 * 1000;
const pad = (n: number) => String(n).padStart(2, "0");

/**
 * 「10/11 19:40」（今年）・「25/10/11 19:40」（違う年。#320 で年2桁に）。受け取った書類の「登録日時」（S3、../eigyouryoku/docs/13 §4.5 の 7）。
 * now はテスト用（省けば今）
 */
export function fmtDateTimeShort(iso: string, now: Date = new Date()): string {
  const d = new Date(new Date(iso).getTime() + JST);
  const y = new Date(now.getTime() + JST).getUTCFullYear();
  const md = `${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
  return d.getUTCFullYear() === y ? md : `${pad(d.getUTCFullYear() % 100)}/${md}`;
}

/**
 * 画面の年月日（#320、2026-11-05 射場さん ★8）：「26/11/05」（年2桁）。'YYYY-MM-DD' でも日時（ISO）でもよい（日時は日本時間の日）。空は ""。
 * 自社の利用者の画面はすべてこれ（乗せると ymdFull の「2026/11/05」）。紙・PDF・メール・送付状・CSV と、相手に見せるページ
 * （閲覧ページ・承諾ページ・確認ページ・協力会社のページ・受領と検収のページ）は4桁のまま（帳票の一部）。
 * 日時（「11/05 01:58」）・月日だけ（「11/05」）は今のまま
 */
export function ymdShort(v: string | null | undefined): string {
  const d = ymdOf(v);
  return d ? `${d.slice(2, 4)}/${d.slice(5, 7)}/${d.slice(8, 10)}` : "";
}
/** 乗せたときの年月日「2026/11/05」（ymdShort の title） */
export function ymdFull(v: string | null | undefined): string {
  const d = ymdOf(v);
  return d ? `${d.slice(0, 4)}/${d.slice(5, 7)}/${d.slice(8, 10)}` : "";
}
/** 'YYYY-MM-DD'（日時は日本時間の日に直す）。読めなければ null */
function ymdOf(v: string | null | undefined): string | null {
  if (!v) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
  if (/^\d{4}-\d{2}-\d{2}T/.test(v)) {
    const t = Date.parse(v);
    return Number.isNaN(t) ? v.slice(0, 10) : new Date(t + JST).toISOString().slice(0, 10);
  }
  return null;
}

/** 画面の日時「26/11/05 01:58」（日本時間。#320 ★8＝年つきの日時も年2桁）。読めなければ "" */
export function ymdHmShort(iso: string | null | undefined): string {
  if (!iso) return "";
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return "";
  const d = new Date(t + JST);
  return `${pad(d.getUTCFullYear() % 100)}/${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}
